<template>
<div>
    <div class="mcc-page-header" fixed="" compact="">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                <section class="mu-d-flex mu-w-100">
                    <h1 class="mu-mb-00">External system connection</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p class="mu-mb-00">
                                {{ (isNewConnection) ? helpTextCreate.title : helpTextEdit.title }}
                                <a class="linkCode" v-if="isNewConnection" :href="helpTextCreate.url" target="_blank">Read more...</a>
                                <a class="linkCode" v-if="!isNewConnection" :href="helpTextEdit.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group" v-if="!isNewConnection">
                        <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportFiles()" title="Export">
                            <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Export</span>
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Integrate</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">External systems</a>
                    </li>
                    <li>
                        <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId">{{externalSystemName}}</router-link>
                    </li>
                    <li>
                        <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId + '/apis/'+ apiId">{{externalSystemAPIName}}</router-link>
                    </li>
                    <li aria-current="page">{{(isNewConnection) ? 'Create new' : connectionName}}</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06">
            <div class="mcc-row" v-if="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mcc-row" v-show="fetchCall">
                <div class="mcc-col">
                    <form ref="databaseConnectionForm" @submit.prevent="saveDatabaseConnection($event)" id="formId" novalidate>
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="externalSystemReadOnly" v-if="isReadOnly" color="warning">
                                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                        <p>
                                            <strong>Warning!</strong>
                                            <br />{{readOnlyMsg}}
                                            <br />
                                        </p>
                                    </mcc-alert>
                                </div>
                            <div class="mcc-row">
                                
                                <div class="mcc-col mcc-col-12 mcc-col-md-6">
                                    <div class="mcc-card">
                                        <div class="mcc-card__header">
                                            <h2 class="mcc-card__title">Active connection </h2>
                                        </div>
                                        <div class="mcc-card__body">
                                            <div class="mcc-row">
                                                <div class="mcc-col mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                                        <label for="database" class="mfc-label--required">Connection type</label>
                                                        <input type="text" id="database" name="database" readonly="" value="DATABASE">
                                                    </div>
                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                                        <label for="name" class="mfc-label--required">Name</label>
                                                        <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" :disabled="isReadOnly" ref="name" :value="dto.databaseName" :pattern="nameRegex" @change="updateName($event)">
                                                    </div>
                                                    <div class="mfc-slim-select-wrapper mu-mb-03">
                                                        <label for="databaseVendor" class="mfc-label--required mu-mb-00">Database vendor</label>
                                                        <select class="mfc-slim-select" :disabled=isReadOnly @change="handleDBVendorChange($event)" ref="daatabaseVendor" name="vendor" id="databaseVendor" required>
                                                            <option :selected="dto.vendor == 'ORACLE'" value="ORACLE">ORACLE</option>
                                                            <option :selected="dto.vendor == 'POSTGRESQL'" value="POSTGRESQL">POSTGRESQL</option>
                                                            <option :selected="dto.vendor == 'SQLSERVER'" value="SQLSERVER">SQLSERVER</option>
                                                            <option :selected="dto.vendor == 'MYSQL'" value="MYSQL">MYSQL</option>
                                                        </select>
                                                    </div>
                                                    <div class="mcc-row" v-if="isShowHostAndService">
                                                        <div class="mcc-col">
                                                            <div class="mfc-input-wrapper mu-d-block connectionMargin mfc-form-input-container mu-mb-03">
                                                                <label for="host" class="mfc-label--required" :label="hostLabel">{{ hostLabel }}</label>
                                                                <input type="text" id="host" name="host" required="" maxlength="60" :disabled="isReadOnly" ref="host" :placeholder="hostLabel" :pattern="helpDocumentationES" :value="dto.host" @change="handleHostChange($event)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mfc-input-wrapper mu-d-block connectionMargin mfc-form-input-container mu-mb-03">
                                                        <label for="port" class="mfc-label--required">Port</label>
                                                        <input type="number" name="port" required="" min="1" max="65535" placeholder="Port" :disabled="isReadOnly" id="port" :value="dto.port" @change="handlePortChange($event)">
                                                    </div>
                                                    <div class="mcc-row" v-if="isShowHostAndService">
                                                        <div class="mcc-col">
                                                            <div class="mfc-input-wrapper mu-d-block connectionMargin mfc-form-input-container mu-mb-03">
                                                                <label for="serviceName" class="mfc-label--required">{{serviceLabel}}</label>
                                                                <input type="text" id="serviceName" name="serviceName" required="" maxlength="30" :disabled="isReadOnly" ref="serviceName" :placeholder="serviceLabel" :pattern="nameRegex" :value="dto.serviceName" @change="handleServiceNameChange($event)">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mfc-input-wrapper mu-d-block connectionMargin mfc-form-input-container mu-mb-03">
                                                        <label for="username" class="mfc-label--required">Username</label>
                                                        <input type="text" id="username" name="username" required="" placeholder="Username" maxlength="30" :disabled="isReadOnly" ref="username" :value="dto.username" @change="dto.username = $event.target.value">
                                                    </div>
                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                                        <label for="password" class="mfc-label--required">Password</label>
                                                        <input type="password" id="password" name="password" required="" maxlength="30" autocomplete="off" placeholder="Password" :disabled="isReadOnly" :value="dto.password" @change="dto.password = $event.target.value">
                                                    </div>
                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                                        <label for="jdbcUrl" class="mfc-label--required">JDBC URL</label>
                                                        <input type="text" id="jdbcUrl" name="jdbcUrl" required="" placeholder="JDBC URL" maxlength="150" readonly="" :disabled="isReadOnly" :value="dto.jdbcUrl">
                                                    </div>

                                                    <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-04">
                                                        <label for="jdbcUrlOverride">JDBC URL Override</label>
                                                        <input type="text" id="jdbcUrlOverride" name="jdbcUrlOverride" placeholder="JDBC URL Override" maxlength="150" :disabled="isReadOnly" :value="dto.jdbcUrlOverride" :pattern="jdbcURL" @change="dto.jdbcUrlOverride = $event.target.value">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mcc-col mcc-col-12 mcc-col-md-6">
                                    <div class="mcc-card card-height">
                                        <div class="mcc-card__header mu-mb-00 mu-d-flex mu-justify-content-between">
                                            <h2 class="mcc-card__title">Additional properties</h2>
                                            <div class="mfc-checkbox-wrapper mfc-form-input-container mu-mb-03">
                                                <input type="checkbox" class="mfc-switch" :disabled="isReadOnly" id="showAdditionaProp" ref="showAdditionaProp" name="showAdditionaProp" :checked="dto.showAdditionalProperties" @change="handleShowAdditionalProperties($event.target.checked)" color="primary">
                                                <label for="showAdditionaProp">Show</label>
                                            </div>
                                        </div>
                                        <div class="mcc-card__body">
                                            <mfc-row-repeater @ready="addRequiredClassToLabels()" ref="customConnectionProperties" id="customConnectionProperties" v-show="dto.showAdditionalProperties">
                                                <mfc-input type="text" label="Name" maxlength="50" name="name" id="addName" :disabled="isReadOnly" dfAttr="dfAttr" class="no-validate"></mfc-input>
                                                <mfc-input type="text" label="Value" maxlength="100" name="value" id="addValue" :disabled="isReadOnly" vfAttr="vfAttr" class="no-validate"></mfc-input>
                                            </mfc-row-repeater>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mcc-row mu-mt-04">
                                <div class="mu-d-flex mu-justify-content-end">
                                    <div role="group" class="mcc-button-group mcc-button-group--spaced mu-mt-03 mcc-button-group-flex-wrap">
                                            <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId + '/apis/'+ apiId" v-if="isNewConnection">
                                                <button class="mcc-button mcc-button--outline mu-mr-05" title="Cancel" id="cancelBtn" type="button">
                                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                </button>
                                            </router-link>
                                       
                                      
                                            <button class="mcc-button mcc-button--soft-danger" v-if="!isNewConnection && !isReadOnly" dialog="deleteDatabaseConnection" title="Delete" id="delDatabaseConBtn" type="button">
                                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                                            </button>
                                        
                                            <button class="mcc-button mcc-button--outline " title="Test connection" id="testConnection" type="button">
                                                <mcc-icon name="connected" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Test connection</span>
                                            </button>
                                        
                                            <button class="mcc-button mcc-button--success" v-if="!isReadOnly" title="Save" id="saveBtn" type="submit">
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                            </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="dataLoaded" color="danger"  id="deleteDatabaseConnection" ref="deleteDatabaseConnection">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete connection</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteDatabaseConnection.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div v-if="!isDefaultConnection">
                        Are you sure you want to delete this database connection?
                    </div>
                    <div v-if="isDefaultConnection">
                        This connection is marked as active. Continue? </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteDatabaseConnection.close()" >No</button>
                        <button type="submit" class="mcc-button mcc-button--danger" @click="deleteDatabaseConnection()">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid';

export default {
    name: "DatabaseConnectionEdit",
    data() {
        return {
            dto: {
                vendor: "ORACLE",
                host: "",
                serviceName: ""
            },
            connectionName: "",
            updateCall: true,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            jdbcURL: constantMessages.PATTERNS["jdbcURL"],
            helpDocumentationES: constantMessages.PATTERNS["helpDocumentationES"],
            externalSystemName: "",
            externalSystemAPIName: "",
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpTextCreate: constantMessages.BREADCRUMB_HELP["externalSystemConnection.database.Create"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["externalSystemConnection.database.edit"],
            externalSystemId: this.$route.params.externalSystemId,
            apiId: this.$route.params.apiId,
            connectionId: this.$route.params.connectionId,
            connectionType: [],
            fetchCall: true,
            isNewConnection: false,
            dataLoaded: false,
            connectionContainer: {},
            isDefaultConnection: false,
            showTestUrl: false,
            addtionalProperties: [],
            hostLabel: "",
            serviceLabel: "",
            isShowHostAndService: true,
            isReadOnly: false,
            isInvalid: false,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"]
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.loadConnectionInfo(false);
        new SlimSelect({
            select: '#databaseVendor',
            settings: {
                closeOnSelect: true
            }
        });
        this.setupMutationObserver()
    },
    methods: {
        setupMutationObserver() {
        const observer = new MutationObserver(() => {
            this.addRequiredClassToLabels();
        });

        const targetNode = this.$el.querySelector('#customConnectionProperties');
        if (targetNode) {
            observer.observe(targetNode, { childList: true, subtree: true });
        }
    },
        addRequiredClassToLabels() {
        this.$nextTick(() => {
            const inputs = this.$el.querySelectorAll('mfc-input');
            
            if (!inputs.length) {
                return;
            }
            
            inputs.forEach(input => {
                const label = input.querySelector('label');
                
                if (label) {
                    if (input.getAttribute('name') === 'name-rr-0' || input.getAttribute('name') === 'value-rr-0') {
                        label.classList.add('mfc-label--required');
                    }
                } 
            });
        });
    },
        handleValidation() {
            let invalid = false;
            let self = this;
            if (!this.dto?.name) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
                invalid = true;
            }
            return invalid;
        },
        handleAddrowEventForRowRepeater() {
            let self = this;
            setTimeout(() => {
                //self.updateCurrentStatusOfDataField();
                //self.updatecurrentStatusOfValueField();
                $(".mc-row-repeater .mc-row-repeater__created-rows .mc-row-repeater__repeated-inputs [dfAttr=dfAttr]").off("change").on("change", function (e) {
                    self.updateDataField(e);
                });
                $(".mc-row-repeater .mc-row-repeater__created-rows .mc-row-repeater__repeated-inputs [vfAttr=vfAttr]").off("change").on("change", function (e) {
                    self.updateValueField(e);
                });
            }, 1000);
        },
        handleRowRemoveOperation() {
            Utils.removeExistingMessages("dfAttr", this.nameRegex, 50);
        },
        updateDataField(event) {
            this.performValidationsForDataField(event.target, event.target.value);
        },
        updateValueField(event) {
            this.performValidationsForValueField(event.target, event.target.value);
        },
        updateCurrentStatusOfDataField() {
            let self = this;
            let alldataFields = $("[dfAttr=dfAttr]");
            $.each(alldataFields, function (i, df) {
                let dataVal = df.value;
                self.performValidationsForDataField(df, dataVal);
            });
        },
        updatecurrentStatusOfValueField() {
            let self = this;
            let allValueFields = $("[vfAttr=vfAttr]");
            $.each(allValueFields, function (i, df) {
                let dataVal = df.value;
                self.performValidationsForValueField(df, dataVal);
            });
        },
        performValidationsForValueField(component, dataVal) {
            let valid = true;
            let pattern = new RegExp(this.descRegex);
            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.required"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (dataVal.length > 100) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.maxlength"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (!pattern.test(dataVal)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.value.invalid"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else {
                Utils.removeExistingMessages("vfAttr", this.descRegex, 50);
                component[0].classList.remove("ms-is-invalid")
                valid = true;
            }
            return valid;
        },
        performValidationsForDataField(component, dataVal) {
            let valid = true;
            let pattern = new RegExp(this.nameRegex);
            if (dataVal == "") {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.name.required"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (dataVal.length > 50) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.maxLength.50"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (!pattern.test(dataVal)) {
                displayErrorMessage($(component), constantMessages.MESSAGES["error.name.invalid"])
                component[0].classList.add("ms-is-invalid")
                valid = false;
            } else if (!Utils.isPropertyValid("dfAttr", "error.name.unique")){
                valid = false;
            }
            else {
                Utils.removeExistingMessages("dfAttr", this.nameRegex, 50);
                component[0].classList.remove("ms-is-invalid")
                valid = true;
            }
            return valid
        },
        handleShowAdditionalProperties(isShowAddProp) {
            let self = this;
            if (isShowAddProp) {
                this.dto.showAdditionalProperties = isShowAddProp;
                self.setRowRepeaterData(self.addtionalProperties);
            } else {
                self.addtionalProperties = [];
                $.each(self.$refs.customConnectionProperties.values, function (i, val) {
                    let obj = {
                        "name": val.Name,
                        "value": val.Value
                    };
                    self.addtionalProperties.push(obj);
                });
                this.dto.showAdditionalProperties = isShowAddProp;
            }
        },
        setRowRepeaterData(addtionalProperties) {
            let self = this;
            if (addtionalProperties.length > 0) {
                setTimeout(() => {
                    self.$refs.customConnectionProperties.setData(addtionalProperties, {});
                }, 1000);
            }
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.dto.databaseName = event.target.value;
        },
        loadConnectionInfo(fetchRef) {
            let self = this;
            self.fetchCall = fetchRef;

            let url =
                "/integrate/external-systems/" +
                self.apiId +
                "/database-connections/" +
                self.connectionId;
            if (self.connectionId == "new") {
                self.isNewConnection = true;
                url =
                    "/integrate/external-systems/" +
                    self.apiId +
                    "/database-connections/api-info";
            }
            ExternalSystemAPI.getConnectionInfo(url)
                .then(result => {
                    if (result == null || result == "") {
                        self.$router.push(self.CONTEXT_PATH + "/integrate/externalsystems");
                        EventBus.$emit("error-notification", {
                            msg: "Error while fetching connection"
                        });
                        return;
                    }
                    self.isReadOnly = result.readOnly;
                    self.connectionContainer = result.connectionInfo;
                    self.externalSystemId = result.connectionInfo.externalSystemId;
                    self.externalSystemName = result.connectionInfo.externalSystemName;
                    self.externalSystemAPIName = result.connectionInfo.externalSystemAPIName;

                    self.dto = result.connectionInfo.connection;
                    self.addtionalProperties = [];
                    $.each(self.dto.customConnectionProperties, function (i, val) {
                        let obj = {
                            "name": val.name,
                            "value": val.value
                        };
                        self.addtionalProperties.push(obj);
                    });
                    if (self.dto.vendor == null) {
                        self.dto.vendor = "ORACLE";
                    }
                    if (self.dto.host == null) {
                        self.dto.host = "";
                    }
                    if (self.dto.serviceName == null) {
                        self.dto.serviceName = "";
                    }
                    self.setLabelsAndPort(self.dto.port);
                    self.connectionName = self.dto.databaseName;
                    self.isDefaultConnection = result.connectionInfo.activeConnectionId != null && result.connectionInfo.activeConnectionId == self.connectionId;
                    self.dataLoaded = true;
                    let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.systemconnection.details"] + " - " + self.connectionName;
                    if (self.isNewConnection) {
                        pageTitle = constantMessages.PAGEHEADER_TITLE["menu.systemconnection.details"] + " - Create new";
                    }
                    EventBus.$emit("update-pageTitle", pageTitle);
                })
                .finally(function () {
                    self.showTestUrl = true;
                    self.fetchCall = true;
                    if (self.dto.showAdditionalProperties) {
                        self.handleShowAdditionalProperties(true);
                    }
                });
        },
        handleDBVendorChange(event) {
            this.dto.vendor = event.target.value;
            this.setLabelsAndPort(null);
        },
        handlePortChange(event) {
            this.dto.port = event.target.value;
            this.prepareJDBCUrl();
        },
        handleServiceNameChange(event) {
            this.dto.serviceName = event.target.value;
            this.prepareJDBCUrl();
        },
        handleHostChange(event) {
            this.dto.host = event.target.value;
            this.prepareJDBCUrl();
        },
        setLabelsAndPort(port) {
            this.isShowHostAndService = false;
            switch (this.dto.vendor) {
                case "ORACLE":
                    this.hostLabel = "Host";
                    this.dto.port = port != null ? port : 1521;
                    this.serviceLabel = "Service name";
                    break;
                case "POSTGRESQL":
                    this.hostLabel = "Server name";
                    this.dto.port = port != null ? port : 5432;
                    this.serviceLabel = "Database";
                    break;
                case "SQLSERVER":
                    this.hostLabel = "Server name";
                    this.dto.port = port != null ? port : 1433;
                    this.serviceLabel = "Database";
                    break;
                case "MYSQL":
                    this.hostLabel = "Host";
                    this.dto.port = port != null ? port : 3306;
                    this.serviceLabel = "Database";
                    break;
                default:
                    this.dto.jdbcUrl = '';
            }
            this.prepareJDBCUrl();
            this.updateShowHostService();
        },
        prepareJDBCUrl() {
            this.dto.jdbcUrl = "";
            switch (this.dto.vendor) {
                case "ORACLE":
                    this.dto.jdbcUrl = "jdbc:oracle:thin:@" + this.dto.host + ':' + this.dto.port + '/' + this.dto.serviceName;
                    break;
                case "POSTGRESQL":
                    this.dto.jdbcUrl = "jdbc:postgresql://" + this.dto.host + ':' + this.dto.port + '/' + this.dto.serviceName;
                    break;
                case "SQLSERVER":
                    this.dto.jdbcUrl = "jdbc:sqlserver://" + this.dto.host + ':' + this.dto.port + ';databaseName=' + this.dto.serviceName;
                    break;
                case "MYSQL":
                    this.dto.jdbcUrl = "jdbc:mysql://" + '' + this.dto.host + ':' + this.dto.port + '/' + this.dto.serviceName;
                    break;
                default:
                    this.dto.jdbcUrl = '';
            }
        },
        async updateShowHostService() {
            await this.$nextTick();
            this.isShowHostAndService = true;
        },
        deleteDatabaseConnection() {
                let self = this;
                self.$refs.deleteDatabaseConnection.close()
                let endPoint = "";
                if (self.isDefaultConnection) {
                    endPoint = "/delete-ref";
                }
                self.updateCall = false;
                ExternalSystemAPI.deleteFileConnection(
                    self.connectionId,
                    self.apiId, endPoint
                ).then(response => {
                    self.updateCall = true;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    this.$router
                        .push(
                            this.CONTEXT_PATH +
                            "/integrate/externalsystems/" +
                            self.externalSystemId +
                            "/apis/" + self.apiId
                        )

                });
        },
        saveDatabaseConnection(e) {
            let form = $('#formId')
            let self = this;
            self.isInvalid = false
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                self.isInvalid = true
            }

            let btnObj = $(document.activeElement);

            if (btnObj[0].id == "testConnection") {
                if(self.isInvalid)
                return
                self.testConnection();
                return;
            }
            let connectionId = self.connectionContainer.externalConnection.id != null ? self.connectionContainer.externalConnection.id : "new";
            if (self.dto.showAdditionalProperties) {
                let customConProp = [];
                let nameFieldComp;
                let nameFieldValue;
                let valueFieldComp;
                let valueFieldvalue
                let isValidNameField = true;
                let isValidValField = true;
                let isValid = true
                $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                    nameFieldComp = $(row).find("input[name^=name]");
                    nameFieldValue = $(nameFieldComp).val();
                    valueFieldComp = $(row).find("input[name^=value]");
                    valueFieldvalue = $(valueFieldComp).val();
                    if ($(nameFieldComp)[0].name !== 'name-rr-0') {
                        isValidNameField = self.performValidationsForDataField(nameFieldComp, nameFieldValue);
                    }
                    if ($(valueFieldComp)[0].name !== 'value-rr-0') {
                        isValidValField = self.performValidationsForValueField(valueFieldComp, valueFieldvalue)
                    }
                    if (!isValidNameField || !isValidValField) {
                        isValid = false
                    }
                })
                if (!isValid || self.isInvalid) {
                    return;
                }

                $(".mcc-row-repeater .mcc-row-repeater__row").each(function (index, row) {
                    nameFieldComp = $(row).find("input[name^=name]");
                    nameFieldValue = $(nameFieldComp).val();

                    valueFieldComp = $(row).find("input[name^=value]");
                    valueFieldvalue = $(valueFieldComp).val();

                    let obj = {
                        "name": nameFieldValue,
                        "value": valueFieldvalue,
                    };
                    customConProp.push(obj);
                })
                customConProp.shift()
                self.dto.customConnectionProperties = customConProp;
            } else {
                if(self.isInvalid)
                return
                self.dto.customConnectionProperties = [];
            }
            self.connectionContainer.connection = self.dto;
            self.updateCall = false;
            ExternalSystemAPI.saveDatabaseConnection(
                self.connectionContainer,
                connectionId,
                self.apiId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                            self.updateCall = true;
                            return;
                        }else if(k == "encrypt"){
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[response.messages[k]]
                            });
                            self.updateCall = true;
                            return;
                        }
                        
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });

                    if (self.isNewConnection) {

                        this.$router
                            .push(
                                this.CONTEXT_PATH +
                                "/integrate/externalsystems/" +
                                self.externalSystemId +
                                "/apis/" + self.apiId +
                                "/database/" + response.data.id
                            )
                    } else {
                        self.loadConnectionInfo(true);
                        self.connectionName = response.data.databaseName;
                    }
                }
            });
        },
        testConnection() {
            let self = this;
            self.updateCall = false;
            ExternalSystemAPI.testDatabaseConnection(
                self.connectionContainer,
                self.connectionId,
                self.apiId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    EventBus.$emit('error-notification', {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });

                }
            });
        },
        exportFiles() {
            ImportExportAPI.exportFiles('DBCONNECTION', this.connectionId);
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(
                this.CONTEXT_PATH + '/integrate/externalsystems'
            );
        }
    }
};
</script>

<style scoped>
.connectionMargin {
    margin-top: 0 !important;
}

.card-height {
    min-height: 100%;
}
</style>
